
<div class="main-container-add-soft-tissue-sample">
<div *ngIf="isAddNewSapleMode"  class="header-container-add-edit-soft-tissue-sample">
    <span><img src="../../assets/icons/soft_tissue_pin.png" alt="New Pin Icon" class="new-soft-tissue-pin-header-icon"> </span>
    <h1 mat-dialog-title  class="add-edit-soft-tissue-sample-header">{{ 'ADD-EDIT-NEW-SAMPLE-DIALOG.NEW-SAMPLE' | translate }}</h1>
</div>
<div *ngIf="isEditSampleMode" class="header-container-add-edit-soft-tissue-sample">
    <span><img src="../../assets/icons/soft_tissue_pin.png" alt="New Pin Icon" class="new-soft-tissue-pin-header-icon"> </span>
    <h1 mat-dialog-title  class="add-edit-soft-tissue-sample-header">{{ 'ADD-EDIT-NEW-SAMPLE-DIALOG.EDIT-SAMPLE' | translate }}</h1>
</div>
<form [formGroup]="softTissueSampleForm">
<div class="add-edit-soft-tissue-sample-input-container">
    <mat-form-field class="add-edit-soft-tissue-sample-input" appearance="outline">
        <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.SAMPLE-ID' | translate }}</mat-label>
        <input matInput formControlName="sampleName">
        <mat-error *ngIf="softTissueSampleForm.get('sampleName').invalid && softTissueSampleForm.get('sampleName').touched"  class="error-notice">
            <strong class="item-required-text">Required* - id/Name</strong>
     </mat-error>
    </mat-form-field>
</div>

<div class="add-edit-soft-tissue-sample-input-container">
    <mat-form-field class="add-edit-soft-tissue-sample-input" appearance="outline">
        <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.BAG-NUMBER' | translate }}</mat-label>
        <input matInput formControlName="bagNumber" maxlength="30">
    </mat-form-field>
</div>

<div class="add-edit-soft-tissue-sample-input-container">
    <mat-form-field class="add-edit-soft-tissue-sample-input" appearance="outline">
        <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.GROWTH-STAGE' | translate }}</mat-label>
<!--        <input matInput formControlName="cropAge" type="number">-->
        <mat-select formControlName="growthStage" >
            <mat-option style="background-color: white!important; padding: 8px!important">
                <div class="select-search-container-md">
                    <div>
                        <ngx-mat-select-search class="select-search" [hideClearSearchButton]="true"
                                               [placeholderLabel]="'Search...'" [clearSearchInput]="true" [noEntriesFoundLabel]="'No Growth Stages Found'"
                                               (ngModelChange)="onGrowthStageSearch($event)" ngModel [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </div>
                </div>
            </mat-option>
            <mat-option *ngFor="let growthStage of filteredGrowthStage" [value]="growthStage?.id">{{growthStage?.name}} {{growthStage?.cropDescription ? '(' + growthStage.cropDescription + ')' : ''}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div class="add-edit-soft-tissue-sample-input-container">
    <mat-form-field class="add-edit-soft-tissue-sample-input" appearance="outline">
        <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.PLANT-PART' | translate }}</mat-label>
        <mat-select   formControlName="plantPart">
            <mat-option *ngFor="let plantPart of plantPartsList" [value]="plantPart" (click)="setSelectedPlantPart(plantPart)">
                {{plantPart.name}}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="softTissueSampleForm.get('plantPart').invalid && softTissueSampleForm.get('plantPart').touched"  class="error-notice">
            <strong class="item-required-text">Required* - plant part</strong>
     </mat-error>
    </mat-form-field>
</div>

<textarea formControlName="note"  class="soft-tissue-sample-note-text-area" name="soil-sample-note"  placeholder="Note:"  rows="4" cols="50" wrap="soft"></textarea>

<div class="add-edit-soft-tissue-sample-input-container">
    <mat-form-field class="add-edit-soft-tissue-sample-input" appearance="outline">
        <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.GROUP' | translate }}</mat-label>
        <mat-select formControlName="pinSampleGroup">
            <mat-option style="background-color: white!important; padding: 8px!important">
                <div class="select-search-container-sm">
                    <div class="select-search-sm">
                <ngx-mat-select-search placeholderLabel="Search Group" [formControl]="groupFilterCtrl">
                    <span ngxMatSelectNoEntriesFound>
                        No entries found
                    </span>
                </ngx-mat-select-search>
            </div>
        </div>
            </mat-option>

            <mat-option *ngFor="let group of filteredSampleGroups | async | orderBy: 'name'"  [value]="group">
                {{group.name}}
              </mat-option>
        </mat-select>
        <mat-error *ngIf="softTissueSampleForm.get('pinSampleGroup').invalid && softTissueSampleForm.get('pinSampleGroup').touched" class="error-notice">
            <strong class="item-required-text">Required* - group </strong>  
        </mat-error>
    </mat-form-field>

    <div class="add-edit-soft-tissue-sample-add-job-container">
        <button class="add-edit-soft-tissue-sample-add-job-btn" mat-flat-button type="button" (click)="addNewGroup()">
            <span class="material-icons" style="color: white; font-size: 24px;">add</span>
        </button>
    </div>
</div>
</form>

<div class="add-edit-soft-tissue-sample-input-container" *ngIf="definitions?.length > 1 || isOrphanedLink">
    <div class="orphaned-warning" *ngIf="isOrphanedLink">
        <mat-icon class="orphaned-icon">warning</mat-icon>
        <span>Linked definition was removed — please reassign</span>
    </div>
    <mat-form-field class="add-edit-soft-tissue-sample-input" appearance="outline">
        <mat-label>Crop Definition</mat-label>
        <mat-select [(ngModel)]="selectedDefinitionId">
            <mat-option [value]="null">— None —</mat-option>
            <mat-option *ngFor="let def of definitions" [value]="def.id">
                {{def.cultivar || 'Definition'}} {{def.cropDescription ? '(' + def.cropDescription + ')' : ''}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<mat-checkbox *ngIf="isEditSampleMode" [(ngModel)]="isCompleted" class="example-margin">Mark as Completed.</mat-checkbox>

<div mat-dialog-actions *ngIf="isAddNewSapleMode">
    <button mat-flat-button (click)="cancel()" type="button" class="cancel-add-edit-soft-tissue-soft-tissue-sample">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.CANCEL' | translate }}</button>
    <button class="add-edit-soft-tissue-soft-tissue-sample-save-btn"  [disabled]="softTissueSampleForm.invalid"  [ngClass]="{'disabled-save-btn': softTissueSampleForm.invalid}" mat-flat-button (click)="saveSample()">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.SAVE' | translate }}</button>
</div>

<div mat-dialog-actions *ngIf="isEditSampleMode">
    <button mat-flat-button (click)="cancel()" type="button" class="cancel-add-edit-soft-tissue-sample">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.CANCEL' | translate }}</button>
    <button class="add-edit-soft-tissue-sample-delete-btn" mat-flat-button (click)="deleteSample()">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.DELETE' | translate }}</button>
    <button class="add-edit-soft-tissue-sample-save-btn" mat-flat-button (click)="updateSample()">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.UPDATE' | translate }}</button>
</div>
</div>
